module.exports = __webpack_public_path__ + "img/public/TrustIcons/Doc.svg?0c85a6dd";